import { ClipBoardCleanupAction } from '../../editor-manager/plugin/clipboard-cleanup-action';
import * as events from '../base/constant';
import { isNullOrUndefined as isNOU, initializeTelemetryFeature } from '@syncfusion/ej2-base';
import { sanitizeHelper } from '../base/util';
/**
 * ClipBoardCleanup module called when copy or cut event is triggered in RichTextEditor
 */
export class ClipBoardCleanup {
    constructor(parent) {
        initializeTelemetryFeature('ClipBoardCleanup', 'RichTextEditor');
        this.parent = parent;
        this.addEventListener();
        this.isDestroyed = false;
    }
    addEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.on(events.clipBoardCleanup, this.clipBoardCleanup, this);
            this.parent.on(events.bindOnEnd, this.bindOnEnd, this);
            this.parent.on(events.destroy, this.destroy, this);
        }
    }
    destroy() {
        if (this.isDestroyed) {
            return;
        }
        this.removeEventListener();
        this.isDestroyed = true;
    }
    removeEventListener() {
        this.parent.off(events.clipBoardCleanup, this.clipBoardCleanup);
        this.parent.off(events.destroy, this.destroy);
        this.parent.off(events.bindOnEnd, this.bindOnEnd);
    }
    bindOnEnd() {
        if (this.parent.editorMode === 'HTML' && this.parent.formatter && this.parent.formatter.editorManager
            && this.parent.contentModule) {
            this.clipBoardCleanupObj =
                new ClipBoardCleanupAction(this.parent.formatter.editorManager);
        }
    }
    /* Handles the copy and cut cleanup operation when copy or cut event is triggered in editor */
    clipBoardCleanup(e) {
        if (!isNOU(e.args)) {
            const range = this.parent.getRange();
            const editableElement = this.parent.contentModule.getEditPanel();
            const operation = e.args.type;
            const clipboardDataArgs = this.clipBoardCleanupObj.handleClipboardProcessing(range, editableElement, operation);
            this.parent.trigger(events.beforeClipboardWrite, clipboardDataArgs, (clipboardWriteArgs) => {
                const htmlText = sanitizeHelper(clipboardWriteArgs.htmlContent, this.parent);
                const plainText = sanitizeHelper(clipboardWriteArgs.plainTextContent, this.parent);
                e.args.clipboardData.setData('text/html', htmlText);
                e.args.clipboardData.setData('text/plain', plainText);
            });
        }
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */
    getModuleName() {
        return 'clipBoardCleanup';
    }
}
